import React from "react";
import { TwoRow } from "../../core/layouts";
import { RightOutlined, SearchOutlined } from "@ant-design/icons";
import Style from "./CustomSelectProductCategory.module.scss";
import { Checkbox, Input, Text } from "react_reusable_components";
import variables from "../../themes/base/styles/variables";

const style = {
  bottomSectionStyle: {
    height: "20rem",
    border: `1px solid ${variables.grey4}`,
    width: variables.fullWidth,
    overflow: "auto",
    borderTop: "none",
  },
  productItemStyle: {
    padding: `${variables.paddingSmaller} ${variables.paddingSmall}`,
    display: variables.dFlex,
    justifyContent: variables.spaceBetween,
    alignItems: variables.alignCenter,
    gap: variables.gapXS,
  },

  rightSectionWrapperStyle: {
    display: variables.dFlex,
    gap: variables.gapXS,
    alignItems: variables.alignCenter,
  },

  productNameStyle: {
    fontSize: variables.fontSizeSmall,
    lineHeight: variables.lineHeightNormal,
    color: variables.textDefault,
  },
  productCountBorderStyle: {
    borderRadius: variables.borderRadius,
    display: variables.dFlex,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: variables.alignCenter,
    padding: "0.13rem 0.5rem",
    gap: variables.gapXS1,
    background: variables.red2,
    color: variables.primaryBg,
    lineHeight: variables.fontSizeNormal,
    fontWeight: variables.fontWeightBold,
    fontSize: variables.fontSizeSmallest,
  },
  rightArrowIconStyle: {
    color: variables.textDefault,
  },
  inputWrapperStyle: {
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    borderRadius: "none",
    padding: `${variables.paddingSmaller} ${variables.paddingSmall}`,
    gap: variables.gapXS,
    fontSize: variables.fontSizeSmall,
    lineHeight: variables.lineHeightNormal,
    color: variables.grey3,
  },
};

const CustomSelectProductCategory = ({
  options,
  placeholder,
  setSearchTerm,
  handleProductCheck,
  onItemSelect,
  isCheckboxVisible,
  showRightArrows,
  lastProductSelected,
}) => {
  return (
    <TwoRow
      topSection={
        <Input
          prefix={
            <SearchOutlined
              style={{
                fontSize: variables.fontSizeNormal,
                color: variables.textDefault,
              }}
            />
          }
          style={style.inputWrapperStyle}
          placeholder={placeholder}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      }
      bottomSection={
        <div style={style.bottomSectionStyle}>
          {options?.map((option) => {
            const count = option?.subCategory?.filter(
              (subCategory) => subCategory?.checked
            )?.length;

            const isIndeterminate =
              count !== 0 && count < option?.subCategory?.length;

            return (
              <div
                style={style.productItemStyle}
                className={`${Style["product-item-style"]} ${
                  lastProductSelected === option.id ? Style["selected"] : ""
                }`}
                key={option?.id}
                onClick={onItemSelect(option?.id)}
              >
                <div style={style.rightSectionWrapperStyle}>
                  {isCheckboxVisible && (
                    <Checkbox
                      indeterminate={isIndeterminate}
                      onChange={handleProductCheck(option?.id)}
                      checked={isIndeterminate ? false : option.checked}
                    />
                  )}
                  <Text style={style.productNameStyle}>{option?.name}</Text>
                </div>

                <div style={style.rightSectionWrapperStyle}>
                  {count > 0 && (
                    <span style={style.productCountBorderStyle}>{count}</span>
                  )}
                  {showRightArrows && (
                    <RightOutlined style={style.rightArrowIconStyle} />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      }
    />
  );
};

export default CustomSelectProductCategory;
